import { supabase } from '../supabaseClient';

export const clientNotesService = {
    async getByClientId(clientId) {
        const { data, error } = await supabase
            .from('client_notes')
            .select('*')
            .eq('client_id', clientId)
            .order('created_at', { ascending: false });
        if (error) throw error;
        return data || [];
    },

    async create(note) {
        const { data, error } = await supabase
            .from('client_notes')
            .insert([note])
            .select()
            .single();
        if (error) throw error;
        return data;
    },

    async update(id, updates) {
        const { data, error } = await supabase
            .from('client_notes')
            .update(updates)
            .eq('id', id)
            .select()
            .single();
        if (error) throw error;
        return data;
    },

    async delete(id) {
        const { error } = await supabase
            .from('client_notes')
            .delete()
            .eq('id', id);
        if (error) throw error;
    }
};
